module.exports = __webpack_public_path__ + "vyhlazeni-vrasek-metodou-laseroveho-resurfacingu_3_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/vyhlazeni-vrasek-metodou-laseroveho-resurfacingu_3_after.jpg
// module id = 1271
// module chunks = 0